import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import './SummaryBookCard.css';

function SummaryBookCard({ _id, slug, title, author, categories, image_url, cefrLevel }) {
    const [bookStatus, setBookStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [hasSubscription, setHasSubscription] = useState(false);

    // دریافت اطلاعات کاربر
    useEffect(() => {
        const userData = localStorage.getItem('currentUser');
        console.log("=== SummaryBookCard - userData ===", userData);
        
        if (userData) {
            try {
                const user = JSON.parse(userData);
                setCurrentUser(user);
                setIsAdmin(user.role === 'admin');
                setHasSubscription(user.subscription?.isActive || false);
                console.log("=== SummaryBookCard - User set ===", user);
            } catch (e) {
                console.error("Error parsing user:", e);
            }
        }
    }, []);

    // بررسی وضعیت کتاب
    useEffect(() => {
        const checkStatus = async () => {
            if (currentUser && !isAdmin && _id) {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/user-book/status/${currentUser._id}/${_id}`);
                    setBookStatus(response.data.status);
                } catch (error) {
                    console.error("Error checking book status:", error);
                    setBookStatus(null);
                }
            }
        };
        
        if (currentUser && !isAdmin && _id) {
            checkStatus();
        }
    }, [_id, currentUser, isAdmin]);

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this book?')) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL}/summary-book/${id}`);
                toast.success('Book deleted successfully!');
                setTimeout(() => window.location.reload(), 1000);
            } catch (error) {
                console.error("Error deleting book:", error);
                toast.error('Failed to delete book');
            }
        }
    };

    const checkSubscriptionAndExecute = (action) => {
        if (!currentUser) {
            toast.error('لطفاً ابتدا وارد شوید');
            window.location.href = '/login';
            return false;
        }
        
        if (!hasSubscription) {
            if (window.confirm('برای استفاده از لیست مطالعه، نیاز به اشتراک فعال دارید. آیا می‌خواهید اشتراک تهیه کنید؟')) {
                window.location.href = '/subscription';
            }
            return false;
        }
        
        action();
        return true;
    };

    const addToStudying = async () => {
        if (isLoading) return;
        setIsLoading(true);
        
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/user-book/studying`, {
                userId: currentUser._id,
                bookId: _id,
                bookType: 'summary'
            });
            setBookStatus('studying');
            toast.success('کتاب به لیست در حال مطالعه اضافه شد');
        } catch (error) {
            console.error("Error:", error);
            toast.error('خطا در عملیات');
        } finally {
            setIsLoading(false);
        }
    };

    const markAsCompleted = async () => {
        if (isLoading) return;
        setIsLoading(true);
        
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/user-book/completed`, {
                userId: currentUser._id,
                bookId: _id
            });
            setBookStatus('completed');
            toast.success('کتاب به لیست مطالعه شده منتقل شد');
        } catch (error) {
            console.error("Error:", error);
            toast.error('خطا در عملیات');
        } finally {
            setIsLoading(false);
        }
    };

    const getCefrBadgeClass = (level) => {
        if (!level) return 'cefr-a1';
        switch (level.toUpperCase()) {
            case 'A1': return 'cefr-a1';
            case 'A2': return 'cefr-a2';
            case 'B1': return 'cefr-b1';
            case 'B2': return 'cefr-b2';
            case 'C1': return 'cefr-c1';
            case 'C2': return 'cefr-c2';
            default: return 'cefr-a1';
        }
    };

    let invalidImage = image_url;
    if (!invalidImage || invalidImage === "") {
        invalidImage = 'https://thecharulathapublications.com/wp-content/uploads/2022/11/book-placeholder.png';
    }

    // استفاده از slug برای لینک، اگر slug نداشت از id استفاده کن (سازگاری با کتاب‌های قدیمی)
    const bookLink = slug ? `/read-summary/${slug}` : `/read-summary/${_id}`;

    let shortenedTitle = title;
    let shortenedAuthor = author;

    const showStudyButtons = currentUser && !isAdmin;

    return (
        <div className="col">
            <div className="card summary-book-card p-1 shadow">
                <div className="d-flex">
                    <div className="col-5 d-flex">
                        <Link to={bookLink}>
                            <img className="img-fluid rounded" style={{ height: '180px', objectFit: 'cover', width: '100%' }} src={invalidImage} alt="" />
                        </Link>
                    </div>
                    <div className="col-7 ps-2">
                        <div className="mb-2">
                            <h6 className="card-title">{shortenedTitle}</h6>
                            <p className="font-size-13 m-0 author-publication lh-1">{shortenedAuthor}</p>
                            {categories && categories.length > 0 && (
                                <div className="categories-container mt-1">
                                    {categories.slice(0, 2).map((cat, idx) => (
                                        <span key={idx} className="category-badge">{cat}</span>
                                    ))}
                                    {categories.length > 2 && <span className="category-badge more">+{categories.length - 2}</span>}
                                </div>
                            )}
                            <div className="cefr-badge mt-1">
                                <span className={`badge ${getCefrBadgeClass(cefrLevel)}`}>📚 {cefrLevel || 'A1'}</span>
                            </div>
                        </div>
                        <div className="d-flex gap-2 flex-wrap">
                            <Link to={bookLink} className="btn lh-1 btn-outline-success">Read Summary</Link>
                            
                            {isAdmin && (
                                <>
                                    <Link to={`/edit-summary-book/${_id}`} className="btn lh-1 btn-outline-warning">Edit</Link>
                                    <button className="btn lh-1 btn-outline-danger" onClick={() => handleDelete(_id)}>Delete</button>
                                </>
                            )}
                            
                            {showStudyButtons && bookStatus !== 'completed' && (
                                <button 
                                    className="btn lh-1 btn-outline-primary" 
                                    onClick={() => checkSubscriptionAndExecute(bookStatus === 'studying' ? markAsCompleted : addToStudying)}
                                    disabled={isLoading}
                                >
                                    {bookStatus === 'studying' ? '✅ اتمام مطالعه' : 'لیست مطالعه+'}
                                </button>
                            )}
                            
                            {showStudyButtons && bookStatus === 'completed' && (
                                <span className="btn lh-1 btn-success disabled" style={{ opacity: 0.6 }}>
                                    ✓ مطالعه شده
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SummaryBookCard;